<template>
  <woot-modal
    :show="showAccountModal"
    :on-close="() => $emit('close-account-modal')"
    class="account-selector--modal"
  >
    <woot-modal-header
      :header-title="$t('SIDEBAR_ITEMS.CHANGE_ACCOUNTS')"
      :header-content="$t('SIDEBAR_ITEMS.SELECTOR_SUBTITLE')"
    />
    <div v-if="isLoading" class="account-selector loading">Loading accounts…</div>
    <div
      v-else
      v-for="account in accounts"
      :key="account.id"
      class="account-selector"
    >
      <a
        :href="`/app/accounts/${account.id}/dashboard`"
        @click.prevent="selectAccount(account)"
      >
        <i v-if="account.id === accountId" class="ion ion-ios-checkmark" />
        <label :for="account.name" class="account--details">
          <div class="account--name">{{ account.name }}</div>
          <div class="account--role">{{ account.role }}</div>
        </label>
      </a>
    </div>
    <div
      v-if="globalConfig.createNewAccountFromDashboard"
      class="modal-footer delete-item"
    >
<!--      <button-->
<!--        class="button success large expanded nice"-->
<!--        @click="$emit('show-create-account-modal')"-->
<!--      >-->
<!--        {{ $t('CREATE_ACCOUNT.NEW_ACCOUNT') }}-->
<!--      </button>-->
    </div>
  </woot-modal>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    showAccountModal: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      isLoading: false,
    };
  },

  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      currentUser: 'getCurrentUser',
      globalConfig: 'globalConfig/get',
    }),
    accounts() {
      const base = this.currentUser.accounts || [];
      const seen = new Set();
      return base.filter(acc => {
        if (!acc || !acc.id) return false;
        if (seen.has(acc.id)) return false;
        seen.add(acc.id);
        return true;
      });
    },
  },
  watch: {
    showAccountModal(val) {
      if (val) this.refreshAccounts();
    },
  },
  created() {
    if (this.showAccountModal) this.refreshAccounts();
  },

  methods: {
    async refreshAccounts() {
      this.isLoading = true;
      try {
        await this.$store.dispatch('validityCheck');
      } catch (e) {
        // If auth is invalid in a fresh/private session, prompt re-login
        this.handleAuthFailure();
        return;
      } finally {
        this.isLoading = false;
      }

      // If no accounts were loaded, treat it as an auth failure and redirect
      if (!this.accounts?.length) {
        this.handleAuthFailure();
      }
    },
    async selectAccount(account) {
      if (!account || !account.id) return;
      this.isLoading = true;
      try {
        // Auth store is not namespaced; dispatch non-namespaced action so the
        // switch works in production builds too.
        await this.$store.dispatch('setUserData', account.id);
        // Ensure navigation happens even if the store call is slow; keep the href as a fallback
        window.location = `/app/accounts/${account.id}/dashboard`;
      } catch (e) {
        // If we fail to set user data, still attempt a hard navigation as a fallback.
        window.location = `/app/accounts/${account.id}/dashboard`;
      } finally {
        this.isLoading = false;
      }
    },
    handleAuthFailure() {
      // Minimal, localized fallback: send the user to re-auth with explicit no-account flag
      window.location = '/app/login?error=no_account';
    },
  },
};
</script>
